module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-2.6dfe25cb.jpg";